import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export function useUnreadConversationCount() {
  const { user } = useAuth();

  const query = useQuery<number>({
    queryKey: ['unread-conversation-count', user?.id ?? null],
    enabled: !!user?.id,
    refetchInterval: 30_000,
    queryFn: async () => {
      if (!user?.id) return 0;
      const { data: conversations, error: convErr } = await supabase
        .from('direct_conversations')
        .select('id')
        .or(`participant_a.eq.${user.id},participant_b.eq.${user.id}`);
      if (convErr) throw convErr;
      const ids = (conversations ?? []).map((c) => c.id);
      if (!ids.length) return 0;

      const { count, error } = await supabase
        .from('direct_messages')
        .select('*', { count: 'exact', head: true })
        .in('conversation_id', ids)
        .neq('sender_id', user.id)
        .is('read_at', null);
      if (error) throw error;
      return count ?? 0;
    },
  });

  return query.data ?? 0;
}
